import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    Header,
    ContentBody,
    HeaderContainer,
    DetailBody,
} from 'src/pages/orders/components/reportsAndInvoice/sendUsageReport/SendUsageReport.styled';
import {
    CloseIconContainer,
    CloseIcon,
} from 'src/pages/orders/components/orderDetails/orderDetailHeader/OrderDetailHeader.styled';
import Close from 'src/assets/images/ModalClose.svg';
import {
    BackButtonIcon,
    BackButtonContainer,
    BackText,
} from 'src/pages/orders/components/searchOrdersPanel/searchOrdersResult/SearchOrdersResult.styled.jsx';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import PdfLoading from './PdfLoading';
import { StyledHorizontalRow } from './ViewReport.styled';
import { isIpad, isMobileView, logErrorToConsole } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { pageNames } from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ViewReport = (props) => {
    const [showPDF, setShowPDF] = useState(false);
    const [pdfPageCounts, setPdfPageCounts] = useState({});
    const { t } = useTranslation();
    const { viewReportBackNavigate } = useSelector(
        (state) => state.viewReportReducer
    );
    const { viewPdfReportData, loading } = useSelector(
        (state) => state.ViewPdfReportReducer
    );

    useEffectWithErrorLogging(() => {
        if (viewPdfReportData && viewPdfReportData.length > 0) {
            setTimeout(() => {
                try {
                setShowPDF(true);
                } catch (error) {
                   logErrorToConsole(error);
                }
            }, 2000);
        }
    }, [viewPdfReportData]);

    useDynatracePageName(pageNames.ordersViewReport);

    const handlePdfLoadSuccess = (pdfIndex, { numPages }) => {
        setPdfPageCounts((prevState) => ({
            ...prevState,
            [pdfIndex]: numPages,
        }));
    };

    return (
        <>
            <ModalDialog
            id="orders-viewreport-modal-dialog"
                modalHeight={'calc(100vh - 110px)'}
                modalWidth={'70%'}
                left={'0%'}
                right={'0%'}
                top={'7%'}
                bottom={'5%'}
                padding={'0px'}
                height={'100%'}
                marginTop={'7rem'}
                zIndex={'2000'}
                onClick={props.onCloseViewReportHandler}
                handleClose={() => props.onCloseViewReportIconHandler()}
            >
                <ContentBody contentHeight={'calc(100% - 16px)'}>
                    <HeaderContainer>
                        <Header fontSize="18px">
                            {t(
                                'orders.reportsAndInvoice.reportsFooter.viewReportButton'
                            )}
                        </Header>

                        {/* <CloseIconContainer>
                            <CloseIcon
                                mobilePath={Close}
                                show={true}
                                onClick={props.onCloseViewReportIconHandler}
                            />
                        </CloseIconContainer> */}
                    </HeaderContainer>
                    <BackButtonContainer
                    id="orders-viewreport-back-button-container"
                        onClick={props.onCloseViewReportHandler}
                    >
                        <BackButtonIcon src={BackIcon} />
                        <BackText>{`${t(
                            'common.backToText'
                        )} ${viewReportBackNavigate}`}</BackText>
                    </BackButtonContainer>

                    <DetailBody
                        detailBodyPadding={'0px'}
                        overflowX={'hidden'}
                        pdfContainerHeight={loading ? '100%' : 'unset'}
                        scrollBarWidth={'8px'}
                        scrollBarBackgroundColor={'#888'}
                        scrollBarBorderRadius={'10px'}
                        mediumDeviceScrollBarDisplay={'block'}
                    >
                        {!loading &&
                        showPDF &&
                        viewPdfReportData &&
                        viewPdfReportData.length > 0 ? (
                            <div className="pdfMainContainer">
                                {viewPdfReportData.map((pdf, index) => {
                                    const numPages = pdfPageCounts[index] || 0;

                                    return (
                                        <React.Fragment key={pdf + `${index}`}>
                                            <Document
                                                file={`data:application/pdf;base64,${pdf}`}
                                                onLoadSuccess={(pdfData) =>
                                                    handlePdfLoadSuccess(
                                                        index,
                                                        pdfData
                                                    )
                                                }
                                                width="100%"
                                                renderMode={'canvas'}
                                                loading={<PdfLoading />}
                                            >
                                                {Array.from(
                                                    { length: numPages },
                                                    (_, pageIndex) => (
                                                        <Page
                                                            pageNumber={
                                                                pageIndex + 1
                                                            }
                                                            scale={
                                                                isIpad() ||
                                                                isMobileView()
                                                                    ? 1.0
                                                                    : 1.5
                                                            }
                                                            key={`${index}-${pageIndex + 1}`}
                                                            style={{
                                                                margin: 0,
                                                                display: 'block',
                                                                padding: 0,
                                                                overflow: 'hidden',
                                                            }}
                                                        />
                                                    )
                                                )}
                                            </Document>
                                            <StyledHorizontalRow />
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        ) : (
                            <PdfLoading />
                        )}
                    </DetailBody>
                </ContentBody>
            </ModalDialog>
        </>
    );
};

export default ViewReport;
